import SubjectDialog from "./subjectDialog"

export default SubjectDialog
